import { render } from "./ActivitySeatingManageView.vue?vue&type=template&id=8fbabe5c&scoped=true"
import script from "./ActivitySeatingManageView.vue?vue&type=script&lang=js"
export * from "./ActivitySeatingManageView.vue?vue&type=script&lang=js"

import "./ActivitySeatingManageView.vue?vue&type=style&index=0&id=8fbabe5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fbabe5c"]])

export default __exports__